import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c87cc0f6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87cc0f6",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/tariff/index.vue
// module id = null
// module chunks = 